import ContentLoader from 'react-content-loader';

const RepresentativeDealLoader = () => {
  const isRTL = document.dir === 'rtl';
  return (
    <ContentLoader
      width="100%"
      height={192}
      viewBox="0 0 250 240"
      style={{
        transform: isRTL ? 'scaleX(-1)' : undefined,
        transformOrigin: 'center',
      }}
    >
      <rect x="0" y="0" rx="0" ry="0" width="90" height="30" />
      <rect x="0" y="40" rx="0" ry="0" width="150" height="30" />

      {/* action button - full width */}
      <rect x="0" y="199" rx="4" ry="4" width="250" height="150" />
    </ContentLoader>
  );
};

export default RepresentativeDealLoader;